import { LocalStorage } from "@js/services/local-storage";

export const refetchUserInOtherTabs = () => {
  LocalStorage.setItem(
    LocalStorage.keys.USER_IN_OTHER_TABS_CHANGED_TIMESTAMP,
    String(new Date().getTime()),
  );
};
